export enum MotorOptionalBenefits {
  HireCar = 'hirecar',
  Windscreen = 'windscreen',
  NCDProtection = 'noClaimDiscountProtection',
  FreeHireCar = 'freehirecar',
}

export enum MotorOptionalBenefitsSitecoreItem {
  HireCar = 'CV-AdditionalCarHire',
  Windscreen = 'CV-FreeWindScreen',
  NCDProtection = 'CV-NoClaimDiscountProtection',
}
